import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const playlistService = {
    getPlaylist,
    savePlaylist,
    saveScene,
    deleteScene,
    deletePlaylist
}

function getPlaylist(orgId) {
    return apiClient.get(`/playlist/${orgId}?withProductData=false`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function savePlaylist(playlist) {
    return apiClient.post(`/playlist`, playlist, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function saveScene(scene) {
    return apiClient.post(`/playlist/scene`, scene, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deleteScene(scene) {
    return apiClient.delete(`/playlist/scene/${scene.sceneId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function deletePlaylist(playlist) {
    return apiClient.delete(`/playlist/${playlist.playlistId}`, {headers: authHeader()})
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));  
}